module.exports = __webpack_public_path__ + "static/img/bg.e73aa69.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/media5/bg.jpg
// module id = KOlB
// module chunks = 7